<template>
  <template v-if="productResponse">
    <SwapModalWrapper
      v-if="productResponse.isTradeInEligible"
      :initialPayload="swapModalStore.initialPayload"
      :modal-name="BUYBACK_MODAL_NAMES.SWAP_MIX_AND_MATCH"
      :price="discountedPrice"
      zone="swap_pp_block"
    />

    <SwapModalWrapper
      v-if="productResponse.isTradeInEligible"
      :image="productResponse.images?.[0]"
      intro="atc"
      :modal-name="BUYBACK_MODAL_NAMES.SWAP_ATC"
      :price="discountedPrice"
      :price-without-trade-in
      :product-title="productResponse.model"
      :redirect-on-close-target="CHECKOUT_ROUTES_NAMES.CART"
      zone="swap_pp_atc"
      @continue="handleContinue"
    />

    <TradeInModal v-if="showTradeInModal" />
  </template>
</template>

<script setup lang="ts">
import { useRuntimeConfig } from '#imports'
import { computed } from 'vue'

import { useBuybackOffer } from '@backmarket/nuxt-layer-buyback/composables/buybackOffer/useBuybackOffer'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import { MODAL_NAMES as BUYBACK_MODAL_NAMES } from '~/scopes/buyback/constants'
import SwapModalWrapper from '~/scopes/buyback/swap/components/SwapModalWrapper/SwapModalWrapper.vue'
import { useSwapModalStore } from '~/scopes/buyback/swap/stores/useSwapModalStore'
import { CHECKOUT as CHECKOUT_ROUTES_NAMES } from '~/scopes/checkout/routes-names'
import { useAddToCartOverlay } from '~/scopes/product-core/composables/stores/useAddToCartOverlay/useAddToCartOverlay'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'
import { useFetchProductPrice } from '~/scopes/product-core/composables/useFetch/useFetchProductPrice/useFetchProductPrice'

import TradeInModal from './components/TradeInModal/TradeInModal.vue'

const { data: productResponse } = useFetchProduct()

const marketPlace = useMarketplace()
const swapModalStore = useSwapModalStore()
const { openAddToCartOverlay } = useAddToCartOverlay()

const {
  FF_PRODUCT_PAGE_TRADE_IN_CHIP_JP = '',
  FF_PRODUCT_PAGE_TRADE_IN_CHIP_AU = '',
} = useRuntimeConfig().public

const { getDiscountedPrice } = useBuybackOffer()
const { priceWithoutSubsidies, priceWithoutTradeIn } = useFetchProductPrice()

const discountedPrice = computed(() =>
  priceWithoutSubsidies.value
    ? getDiscountedPrice(priceWithoutSubsidies.value)
    : undefined,
)

const showTradeInModal = computed(() => {
  return (
    FF_PRODUCT_PAGE_TRADE_IN_CHIP_AU.includes(marketPlace.market.countryCode) ||
    FF_PRODUCT_PAGE_TRADE_IN_CHIP_JP.includes(marketPlace.market.countryCode) ||
    productResponse.value?.isTradeInEligible
  )
})

function handleContinue() {
  setTimeout(() => {
    openAddToCartOverlay()
  })
}
</script>
